import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const state = {
  fetching:false,
  last_added_lead:null,
  leads:[],
  currently_consulted_lead:null,
  seach_params:null,
  forms:[],
  contacts:[],
  customers:[],
  errors:[],
  users:[], // TODO remove
  interactions:[],
  offers :  [],
  distribution_methods : [],
  agencies:[],
  medias:[],
  leads_for_export:[],
  user_groups: [],
  search_params: {}
}

const mutations = {
  [types.CRM_LEADS_RECEIVED] (state, payload)
  {
    state.leads = payload.leads
    console.log("leads received")
  },
  [types.CRM_LEAD_RECEIVED] (state, payload)
  {
    state.currently_consulted_lead = payload.lead
    console.log("lead received")
  },
  [types.CRM_LEAD_ADDED] (state, payload)
  {
    console.log("lead added")
    state.last_added_lead = payload.lead
  },
  [types.CRM_CONTACTS_OF_LEAD_RECEIVED] (state, payload)
  {
    var exist = _.find(state.contacts, ctc => ctc.lead_id == payload.lead_id)
    if (exist === undefined)
      state.contacts.push(payload)
    else {
      var idx = _.indexOf(state.contacts, exist)
      state.contacts[idx] = payload
    }
    console.log("lead's contacts received")
  },
  [types.CRM_CONTACT_ADDED_TO_LEAD] (state, payload, lead_id)
  {
    console.log("lead's contact added")
  },
  [types.CRM_CREATE_CONTACT_FORM_RECEIVED] (state, payload)
  {
    var exist = _.find(state.forms, f => f.lead_id == payload.lead_id && f.flag)
    if (exist === undefined)
      state.forms.push(payload)
    else {
      var idx = _.indexOf(state.forms, exist)
      state.forms[idx] = payload
    }
    console.log("lead's creation form for contacts addition")
  },
  [types.CRM_EDIT_CONTACT_FORM_RECEIVED] (state, payload)
  {
    // debugger
    var exist = _.find(state.forms, f => f.lead_id == payload.lead_id && f.contact_id == payload.contact_id && !f.flag)
    if (exist === undefined)
      state.forms.push(payload)
    else {
      var idx = _.indexOf(state.forms, exist)
      state.forms[idx] = payload
    }
    console.log("lead's edition form for contact edition")
  },
  [types.CRM_CONTACT_EDITED] (state, payload)
  {
    console.log("lead's contacts edited")
  },
  [types.CRM_CONTACT_REMOVED] (state, payload)
  {
    console.log("lead's contacts removed")
    state.contacts = []
  },
  [types.CRM_CUSTOMERS_RECEIVED](state, payload)
  {
    state.customers = payload.customers
    console.log("customers fetched")
  },
  [types.CRM_ATTACH_CUSTOMER_TO_LEAD] (state, payload)
  {
    console.log("binding customer to lead")
  },
  [types.CRM_UNATTACH_CUSTOMER_FROM_LEAD] (state, payload)
  {
    console.log("unbinding customer to lead")
  },
  [types.CRM_USERS_FETCHED] (state, payload)
  {
    if (_.find(state.users, u => u.id != payload.id) == undefined)
      state.users.push(payload.user)
  },
  [types.CRM_INTERACTIONS_RECEIVED](state, payload)
  {
    console.log("interactions received")
    state.interactions = payload.lead_interactions
  },
  [types.CRM_INTERACTION_CREATED](state, payload)
  {
    console.log("interactions created")
  },
  [types.CRM_INTERACTION_DELETED](state, payload)
  {
    console.log("interactions deleted")
  },
  [types.CRM_INTERACTION_UPDATED](state, payload)
  {
    console.log("interactions updated")
  },
  [types.CRM_OFFERS_RECEIVED](state, payload)
  {
    console.log("offers received")
    state.offers = payload.offers
  },
  [types.CRM_OFFER_ATTACHED](state, payload)
  {
    console.log("offer attached to lead")
  },
  [types.CRM_OFFER_DETACHED](state, payload)
  {
    console.log("offer detached from lead")
  },
  [types.CRM_DISTRIBUTION_METHOD_ATTACHED](state, payload)
  {
    console.log("distribution method attached to lead")
  },
  [types.CRM_DISTRIBUTION_METHOD_DETACHED](state, payload)
  {
    console.log("distribution method detached from lead")
  },
  [types.CRM_DISTRIBUTIONS_METHODS_RECEIVED](state, payload) {
    console.log("distribution_methods received")
    state.distribution_methods = _.filter(payload.distribution_methods, dm => dm.id == 1 || dm.id == 2 || dm.id == 4)
    // state.distribution_methods.push({id:7, display_name:"Permanence téléphonique"})
  },
  [types.CRM_AGENCIES_RECEIVED](state, payload)
  {
    console.log('agencies received')
    state.agencies = payload.agencies
  },
  [types.CRM_MEDIAS_RECEIVED](state, payload)
  {
    console.log("medias received")
    _.each(payload, (received_media) => {
      var existing = _.find(state.medias, m => m.id == received_media.id)
      if (existing)
      {
        var idx = _.indexOf(state.medias, existing)
        if (state.medias[idx].checked)
          received_media.checked = true
        state.medias[idx] = _.merge(state.medias[idx], received_media)
      }
      else {
        state.medias = _.concat(state.medias, [received_media])
      }
    })
  },
  [types.CRM_SCHEDULED_INTERACTION_CREATED](state, payload)
  {
    console.log("SCHEDULED interaction created")
  },
  [types.CRM_SCHEDULED_INTERACTION_UPDATED](state, payload)
  {
    console.log("SCHEDULED interaction updated")
  },
  [types.CRM_SCHEDULED_INTERACTION_REALIZED](state, payload)
  {
    console.log("SCHEDULED interaction realized")
  },
  [types.CRM_LEAD_STATUS_UPDATED](state, payload)
  {
    console.log("LEAD status updated")
  },
  [types.CRM_LEAD_FOR_EXPORT](state, payload)
  {
    state.leads_for_export = payload.leads
  },
  [types.CRM_LEAD_ORIGIN_SUPPLEMENT_UPDATED](state, payload)
  {
    console.log("Lead origin supplement updated")
  },
  [types.CRM_LEAD_DELETED](state, payload)
  {
    console.log("lead deleted")
  },
  [types.CRM_LEAD_AGENCY_UPDATED](state, payload)
  {
    console.log("lead agency updated")
  },
  [types.CRM_OFFER_SUPPLEMENT_UPDATED](state, payload)
  {
    console.log("lead offer supplemnt updated")
  },
  [types.CRM_USER_GROUPS_RECEIVED] (state, payload)
  {
    state.user_groups = payload.user_groups
    console.log("user groups received")
  }
}

const actions  = {
  set_fetching_state({state}, fetch_state)
  {
    state.fetching = fetch_state
  },

  fetch_all_leads({commit, state}, params)
  {
    // params = _.assign(params, {per_page:10}) // Uncomment if you don't want to create 25 leads before being able to see the pagination works
    // params = _.assign(params, {with:"creating_users"})
    return api.get_all_leads(params)
              .then((response) => commit(types.CRM_LEADS_RECEIVED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  fetch_all_leads_for_export({commit, state}, params)
  {
    params = _.assign(params, {paginate:0})
    return api.get_all_leads(params)
              .then((response) => commit(types.CRM_LEAD_FOR_EXPORT, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  fetch_a_lead({commit, state}, lead_id)
  {
    return api.get_lead(lead_id)
              .then((response) => commit(types.CRM_LEAD_RECEIVED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  create_a_lead({commit, state}, params)
  {
    return api.add_lead(params)
              .then((response) => commit(types.CRM_LEAD_ADDED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))

  },

  fetch_all_contacts({commit, state}, lead_id)
  {
    return api.get_all_contacts_of(lead_id)
              .then((response) => commit(types.CRM_CONTACTS_OF_LEAD_RECEIVED, {lead_id:lead_id, contacts:response.data.length != 0 ? response.data.contacts : []}))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  add_contact_to_lead({commit, state}, params)
  {
    return api.add_contact_to(params.lead_id, {contact:params.params.data.contact})
              .then((response) => commit(types.CRM_CONTACT_ADDED_TO_LEAD, response.data))
              // .catch((error) => state.errors.push(error.response.data.errors))
  },

  fetch_contact_creation_form({commit, state}, lead_id)
  {
    return api.get_contact_creation_form_for(lead_id)
              .then((response) => commit(types.CRM_CREATE_CONTACT_FORM_RECEIVED, {lead_id:lead_id, form:response.data.form, flag:true}))
              // .catch((error) => state.errors.push(error.response.data.errors))
  },

  fetch_contact_edition_form({commit, state}, params)
  {
    return api.get_contact_edition_form_for(params.lead_id, params.contact_id)
              .then((response) => commit(types.CRM_EDIT_CONTACT_FORM_RECEIVED,  {lead_id:params.lead_id, form:response.data.form, flag:false, contact_id:params.contact_id}))
              // .catch((error) => state.errors.push(error.response.data.errors))
  },

  update_contact_of_lead({commit, state}, params)
  {
    return api.update_contact_of(params.lead_id, params.contact_id, params.body)
              .then((response) => commit(types.CRM_CONTACT_EDITED, response.data))
              // .catch((error) => state.errors.push(error.response.data.errors))
  },

  remove_contact_of_lead({commit, state}, params)
  {
    return api.delete_contact_of(params.lead_id, params.contact_id)
              .then((response) => commit(types.CRM_CONTACT_REMOVED, response.data))
              // .catch((error) => state.errors.push(error.response.data.errors))
  },

  update_offer_supplement({commit, state}, params)
  {
    return api.put_lead_offer_supplement(params)
              .then((response) => commit(types.CRM_OFFER_SUPPLEMENT_UPDATED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  reset_form({state}, forms)
  {
    state.forms = forms
  },

  reset_errors({state})
  {
    state.errors = []
    state.fetching = false
  },

  reset_error({state}, errorkey)
  {
    state.errors = _.map(state.errors, err => {
        delete err[errorkey]
        return err
      })
  },

  reset_form_errors({rootState})
  {
    rootState.formError = {}
  },

  reset_consulted_lead({state})
  {
    state.currently_consulted_lead = null
  },

  set_search_params({state}, sparams)
  {
    Vue.set(state, 'search_params', _.assign(state.search_params, sparams))
  },

  fetch_customers({commit, state}, params)
  {
    var params = _.assign(params, {with:"main_address"})
    return api.fetchCustomers(params)
                .then((response) => commit(types.CRM_CUSTOMERS_RECEIVED, response.data))
                .catch((error) => state.errors.push(error.response.data.errors))
  },

  reset_customers({state})
  {
    state.customers = []
  },

  attach_lead({commit, state}, params) {
    return api.attach_lead(params.lead_id, params.customer_id)
              .then((response) => commit(types.CRM_ATTACH_CUSTOMER_TO_LEAD, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  unattach_lead({commit, state}, params) {
    return api.unattach_lead(params.lead_id)
              .then((response) => commit(types.CRM_UNATTACH_CUSTOMER_FROM_LEAD, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },
  // get_user_info({commit}, uid) {
  //   return api.getUser(uid)
  //           .then((response) => {
  //             commit(types.CRM_USERS_FETCHED, response.data)
  //           })
  //         .catch ((error) => state.errors.push(error.response.data.errors))
  // },
  reset_users({state})
  {
    state.users =[]
  },

  fetch_interactions({commit, state}, lead_id)
  {
    return api.get_interactions(lead_id)
              .then((response) => commit(types.CRM_INTERACTIONS_RECEIVED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  create_interaction({commit, state}, params)
  {
    return api.post_interaction(params.lead_id, params)
              .then((response) => commit(types.CRM_INTERACTION_CREATED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  create_scheduled_interaction({commit, state}, params)
  {
    return api.schedule_interaction(params.lead_id, params)
              .then((response) => commit(types.CRM_SCHEDULED_INTERACTION_CREATED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  destroy_interaction({commit, state}, params)
  {
    return api.delete_interaction(params.lead_id, params.lead_interaction_id)
              .then((response) => commit(types.CRM_INTERACTION_DELETED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  update_interaction({commit, state}, params)
  {
    return api.put_interaction(params.lead_id, params.lead_interaction_id, params.params)
              .then((response) => commit(types.CRM_INTERACTION_UPDATED, response.data))
              .catch((error) => state.errors.push({'edition_interaction':["Edition d'une interaction: " + error.response.data.message.split(':')[1]]}))
  },

  update_scheduled_interaction({commit, state}, params)
  {
    return api.update_schedule_interaction(params.lead_id, params.lead_interaction_id, params.params)
              .then((response) => commit(types.CRM_SCHEDULED_INTERACTION_UPDATED, response.data))
              .catch((error) => state.errors.push({'edition_interaction':["Edition d'une interaction planifié: " + error.response.data.message.split(':')[1]]}))
  },

  realize_interaction({commit, state}, params)
  {
    return api.realize_schedule_interaction(params.lead_id, params.lead_interaction_id, params.params)
              .then((response) => commit(types.CRM_SCHEDULED_INTERACTION_REALIZED, response.data))
              .catch((error) => state.errors.push({'edition_interaction':["Réalisation d'une interaction planifié: " + error.response.data.message.split(':')[1]]}))
  },

  attach_offer_to_lead({commit, state}, params)
  {
    return api.post_offer_to_lead(params.lead_id, {offer_id:params.offer_id})
              .then((response) => commit(types.CRM_OFFER_ATTACHED, response.data))
              .catch((error) => {
                if (error.response.data.hasOwnProperty("errors"))
                  state.errors.push(error.response.data.errors)
                else {
                  state.errors.push({offres:["Offres: " + error.response.data.message]})
                }
              })
  },
  
  detach_offer_of_lead({commit, state}, params)
  {
    return api.delete_offer_of_lead(params.lead_id, params.offer_id)
    .then((response) => commit(types.CRM_OFFER_DETACHED, response.data))
    .catch((error) => state.errors.push(error.response.data.errors))
  },
  
  attachDistributionMethodTolead({commit, state}, params)
  {
    return api.attachDistributionMethodToLead(params.lead_id, {distribution_method_id:params.distribution_method_id})
              .then((response) => commit(types.CRM_DISTRIBUTION_METHOD_ATTACHED, response.data))
              .catch((error) => {
                if (error.response.data.hasOwnProperty("errors"))
                  state.errors.push(error.response.data.errors)
                else {
                  state.errors.push({offres:["Types d'offre: " + error.response.data.message]})
                }
              })
  },

  detachDistributionMethodFromLead({commit, state}, params)
  {
    return api.detachDistributionMethodFromLead(params.lead_id, params.distribution_method_id)
              .then((response) => commit(types.CRM_DISTRIBUTION_METHOD_DETACHED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  reset_interactions({state})
  {
    state.interactions = []
  },

  fetch_offers({state, commit}, params)
  {
    return api.fetchOffers(params)
              .then((response) => commit(types.CRM_OFFERS_RECEIVED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))

  },

  reset_offers({state})
  {
    state.offers = []
  },

  fetch_distributions_methods({state, commit})
  {
    return api.get_distribution_methods()
              .then((response) => commit(types.CRM_DISTRIBUTIONS_METHODS_RECEIVED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))

  },

  fetch_medias({state, commit}, agency_id)
  {
    return api.get_medias(agency_id)
              .then((response) => {
                commit(types.CRM_MEDIAS_RECEIVED, _.map(response.data, d => {
                  var r =  _.assign(d, {agency_id:agency_id, checked:false})
                  return r
                }))
              })
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  update_checkstate_of_medias({state}, params)
  {
    state.medias = _.map(state.medias, m => {
      if (m.id == params.media_id)
        m.checked = !m.checked
      return m
    })
    state.medias = _.filter(state.medias, m => {
      return _.some(params.sa, (a) => a === m.agency_id) || m.checked
    })
  },

  fetch_agencies({state, commit})
  {
    return api.fetchAgencies()
              .then((response) => commit(types.CRM_AGENCIES_RECEIVED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  reset_medias({state})
  {
    state.medias = _.filter(state.medias, m => m.checked)
  },

  set_medias({state}, ms)
  {
    state.medias = ms
  },

  update_lead_status({state, commit}, params)
  {
    return api.put_lead_status(params.lead_id, params.params)
              .then((response) => commit(types.CRM_LEAD_STATUS_UPDATED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  update_lead_agency({state, commit}, params)
  {
    return api.put_lead_agency(params.lead_id, params.params)
              .then((response) => commit(types.CRM_LEAD_AGENCY_UPDATED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  remove_lead({state, commit}, params)
  {
    return api.delete_lead(params.lead_id)
              .then((response) => commit(types.CRM_LEAD_DELETED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  clear_current_lead({state})
  {
    state.currently_consulted_lead = null
  },

  reset_leads({state}, lds)
  {
    state.leads.data = lds
  },

  update_lead({commit}, params)
  {
    return api.put_lead(params.lead_id, params.body)
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  fetchCrmRelatedUserGroups({state, commit})
  {
    return api.getCrmUserGroups({crm_related: 1})
              .then((response) => commit(types.CRM_USER_GROUPS_RECEIVED, response.data))
              .catch((error) => state.errors.push(error.response.data.errors))
  },

  updateLeadManager({state, commit}, params)
  {
    return api.updateLeadManager(params.lead_id, params.params)
              .catch((error) => state.errors.push(error.response.data.errors))
  }
}

const getters = {
  leads(state)
  {
    return state.leads
  },

  page_of_leads(state)
  {
    return state.leads.data
  },

  current_lead(state)
  {
    return state.currently_consulted_lead
  },

  errors(state)
  {
    return state.errors
  },

  is_any_errors(state)
  {
    return state.errors.length > 0
  },

  forms(state)
  {
    return state.forms
  },

  is_fetching(state)
  {
    return state.fetching
  },

  search_params(state)
  {
    return state.search_params
  },

  customers(state)
  {
    return state.customers
  },

  customers_as_options(state)
  {
    var res = _.map(state.customers, customer => { return {id:customer.id, text:customer.name}})
    return res
  },

  contacts(state)
  {
    return state.contacts
  },

  contacts_of_lead(state, getters)
  {
    var exists = _.find(getters.contacts, ctc => ctc.lead_id == getters.current_lead.id)
    if (exists != undefined)
      return exists.contacts
    else
      return []
  },

  interactions(state)
  {
    return state.interactions != undefined ? _.reverse(_.sortBy(state.interactions, 'interaction_date')) : []
  },

  offers(state)
  {
    if (state.currently_consulted_lead)
      return state.currently_consulted_lead.offers
    return []
  },

  available_offers(state)
  {
    return _.map(state.offers, o => { return {id:o.id, text:o.name}})
  },

  distribution_methods(state)
  {
    // add here condition for hiding undesired distribution_methods
    return _.map(state.distribution_methods, dm => { return {id:dm.id, text:dm.display_name}})
  },

  medias(state)
  {
    return state.medias
  },

  agencies(state)
  {
    return state.agencies
  },

  leads_to_export(state)
  {
    return state.leads_for_export
  },

  userGroups(state)
  {
    return state.user_groups
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./client/store/modules/crm.js